import { NavLink } from 'react-router-dom';
import styles from './rsidebar.component.less'
import React from "react";
function RSidebar(props)
{
     let content= props.data.map(x=>{
          return (
               <NavLink key={x.id} to={`/tag/${x.name}`}>
                    {x.name}
               </NavLink>
          );
     })
    return (
        <div className={styles.rsidebar}>
           <div className={styles.tags}>
            <h2>#tags</h2>
            <div>
              {content}
            </div>
        </div>
        </div>
    );
}

export default RSidebar;